import axios from 'axios';
import { nanoid } from "nanoid";

const headers = {
  headers: {
    "x-api-key": "qIaQZ7nSzt8takE2wP7MY4GxE8NSTaHB4Gj2b3xW"
  }
};

export async function imageUploader(imageDataUrl) {
  try {
    const boldBuilderId = nanoid();
    try {
      const fileBlob = await dataURLtoBlob(imageDataUrl);

      const fileExtension = getFileExtensionFromDataUrl(imageDataUrl); // e.g., 'png'
      const filename = `${boldBuilderId}.${fileExtension}`;

      // Convert Blob to binary string
      const fileBinaryString = await readBlobAsBinaryString(fileBlob);

      const body = {
        id: boldBuilderId,
        filename: filename,
        file: fileBinaryString,
      };

      const response = await axios.post(`${process.env.API_URL}/photo/upload`, JSON.stringify(body), headers);

      if (response.status >= 200 && response.status < 300) {
        response.data.url;

        sessionStorage.setItem("messageCardImage", response.data.url)
      } else {
        console.error('failed:', response.status, response.statusText);
        console.error('response:', response.data);
      }
    } catch (error) {
      console.error('error:', error);
    }

  } catch (error) {
    console.error('Error uploading file:', error);
  }
}

export async function dataURLtoBlob(dataURL) {
  const parts = dataURL.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}

function getFileExtensionFromDataUrl(dataUrl) {
  const mimeType = dataUrl.split(';')[0].split(':')[1]; // e.g. "image/png"
  return mimeType.split('/')[1]; // e.g. "png"
}

function readBlobAsBinaryString(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => resolve(e.target.result);
    reader.onerror = e => reject(e);
    reader.readAsBinaryString(blob);
  });
}
